import { ReactComponent as SvgBacterialDnaOutline } from 'assets/svg/bacterial-dna-outline.svg';
import { ReactComponent as SvgBacterialDna } from 'assets/svg/bacterial-dna.svg';
import { ReactComponent as SvgEcoli } from 'assets/svg/ecoli.svg';
import { ReactComponent as SvgPlasmidOutline } from 'assets/svg/plasmid-outline.svg';
import { ReactComponent as SvgPlasmid } from 'assets/svg/plasmid.svg';
import EcoliDraggable from 'components/EcoliDraggable';
import OperonDropTarget from 'components/OperonDropTarget';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { IEcoli } from 'stores/models/Ecoli';
import { IOperon } from 'stores/models/LacOperon';
import { DragAndDropTypes } from 'stores/models/types';
import SectionHeader from './SectionHeader';

interface IProps {
  ecoli: IEcoli;
  operonBacterial: IOperon;
  operonPlasmid: IOperon;
  onEcoliChange: (ecoli?: IEcoli) => void;
  onEcoliDragStart: () => void;
}

interface IState {
  vmBacterial: IOperon | null;
  vmPlasmid: IOperon | null;
}

class View extends Component<IProps, IState> {
  defaultState: IState = {
    vmBacterial: null,
    vmPlasmid: null,
  };
  refVmBacterial: any = null;
  refVmPlasmid: any = null;

  constructor(props: IProps) {
    super(props);

    this.state = this.defaultState;
  }

  private reset = () => {
    this.setState(this.defaultState);
    this.refVmBacterial.reset();
    this.refVmPlasmid.reset();
    this.props.onEcoliChange();
  };

  private onDropSuccess = (model: IOperon) => {
    const { ecoli, onEcoliChange } = this.props;
    const { type } = model.info;
    const copyDNA = model.copy();
    const isBacterialCopy = type === DragAndDropTypes.BacterialDNA;
    const isPlasmidCopy = type === DragAndDropTypes.PlasmidDNA;

    if (isBacterialCopy) {
      this.setState({ vmBacterial: copyDNA });
    } else if (isPlasmidCopy) {
      this.setState({ vmPlasmid: copyDNA });
    }

    const isCopyPlasmid: boolean = isPlasmidCopy || !!this.state.vmPlasmid;
    const copyEcoli = ecoli.copy(isCopyPlasmid);
    onEcoliChange(copyEcoli);
  };

  render() {
    const {
      ecoli,
      operonBacterial,
      operonPlasmid,
      onEcoliDragStart,
    } = this.props;
    const { vmBacterial, vmPlasmid } = this.state;
    const isEcoliDraggable = !!vmBacterial;
    const isDisabled = !vmBacterial && !vmPlasmid;

    return (
      <div className='card has-border-1 is-shadowless mr-5 p-5 is-flex-grow-1 has-flex-basis-0'>
        <SectionHeader isDisabled={isDisabled} step={2} onReset={this.reset}>
          <span className='has-text-grey is-size-7'>
            <span className='has-text-weight-semibold'>
              <span className='is-italic'>Drop</span> the DNA molecule(s) then{' '}
              <span className='is-italic'>drag</span> the E. coli
            </span>{' '}
            <br />
            <span className='has-text-grey-light'>
              Four E. coli instances are created (one per test tube)
            </span>
          </span>
        </SectionHeader>

        <div className='is-flex is-flex-grow-1'>
          <div className='is-flex-direction-column is-flex-grow-1 mr-4'>
            <OperonDropTarget
              ref={(el) => (this.refVmBacterial = el)}
              isRequired={true}
              model={operonBacterial}
              onDropSuccess={this.onDropSuccess}
            >
              {vmBacterial ? <SvgBacterialDna /> : <SvgBacterialDnaOutline />}
            </OperonDropTarget>
            <hr className='is-divider-2 has-background-transparent' />
            <OperonDropTarget
              ref={(el) => (this.refVmPlasmid = el)}
              isRequired={false}
              model={operonPlasmid}
              onDropSuccess={this.onDropSuccess}
            >
              {vmPlasmid ? <SvgPlasmid /> : <SvgPlasmidOutline />}
            </OperonDropTarget>
          </div>
          <div className={`is-flex-centered is-flex-direction-column`}>
            <EcoliDraggable
              model={ecoli}
              isDraggable={isEcoliDraggable}
              onDragStart={onEcoliDragStart}
            >
              <SvgEcoli />
            </EcoliDraggable>
            <div className='is-size-7 has-text-centered mt-2'>
              {ecoli.info.label}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const Section2 = observer(View);
export default Section2;
